// export this package's api
'use strict';

module.exports = require('./Upload');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-upload/lib/index.js
 ** module id = 396
 ** module chunks = 0
 **/